import { setCookie } from '@/helpers/cookies';
import store from '@/store';

export default function usePets() {
  const choosePet = async (pet) => {
    setCookie('v-search-pet', pet.uuid, '1h');
    setCookie(
      'v-search-species-treated',
      JSON.stringify([pet.species]),
      '1h',
    );
    await store.commit('search/setInputs', {
      pet_uuid: pet.uuid,
      species_treated: [pet.species],
    });
  };

  return {
    choosePet,
  };
}
